export default "/images/twitch.svg?04cf8669f81068d40a26fd8bf1f75de9";